import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import * as React from "react";
import { WeeklyActivityTable } from "./WeeklyActivityTable";

interface WeeklyActivityProps {
  metrics: any;
  weeklyGrid: any;
  showTestFBOs: boolean;
  onShowTestFBOsChange: (value: boolean) => void;
}

export const WeeklyActivity: React.FC<WeeklyActivityProps> = ({
  metrics,
  weeklyGrid,
  showTestFBOs,
  onShowTestFBOsChange,
}) => {
  return (
    <>
      {/* Metrics Cards */}
      {metrics && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                borderRadius: 2,
                boxShadow: "none",
                "&:hover": {
                  boxShadow: 1,
                },
              }}
            >
              <CardContent>
                <Typography variant="body1" color="text.primary" gutterBottom>
                  Total Customers
                </Typography>
                <Typography
                  variant="h2"
                  sx={{ fontSize: "3rem", fontWeight: 600 }}
                >
                  {metrics.total_customers}
                </Typography>
                <Typography
                  variant="body2"
                  color={
                    metrics.total_customers_change > 5
                      ? "success.main"
                      : "text.secondary"
                  }
                >
                  {metrics.total_customers_change > 0 ? "+" : ""}
                  {metrics.total_customers_change || 0} this month
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                borderRadius: 2,
                boxShadow: "none",
                "&:hover": {
                  boxShadow: 1,
                },
              }}
            >
              <CardContent>
                <Typography variant="body1" color="text.primary" gutterBottom>
                  Weekly Active
                </Typography>
                <Typography
                  variant="h2"
                  sx={{ fontSize: "3rem", fontWeight: 600 }}
                >
                  {metrics.weekly_active}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {metrics.weekly_active_percent}% of total customers
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                borderRadius: 2,
                boxShadow: "none",
                "&:hover": {
                  boxShadow: 1,
                },
              }}
            >
              <CardContent>
                <Typography variant="body1" color="text.primary" gutterBottom>
                  Monthly Active
                </Typography>
                <Typography
                  variant="h2"
                  sx={{ fontSize: "3rem", fontWeight: 600 }}
                >
                  {metrics.monthly_active}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {metrics.monthly_active_percent}% of total customers
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      <Divider />

      {/* Weekly Activity Grid */}
      <Box
        sx={{
          width: "100%",
          // Remove overflow here as it's handled in the table component
          pb: 2,
          boxSizing: "border-box",
        }}
      >
        <WeeklyActivityTable
          weeklyGrid={weeklyGrid}
          showTestFBOs={showTestFBOs}
          onShowTestFBOsChange={onShowTestFBOsChange}
        />
      </Box>
    </>
  );
};
